import { TopicPreview } from "./topics";
import { cleanObj } from "./utils";
import type { PortableTextBlock } from "@portabletext/types";

const url = "/api/v1/articles";

export type ArticlePreview = {
  _id: string;
  heroImageAlt: string;
  heroImageSrc: string;
  isLocked: boolean;
  slug: string;
  title: string;
  topic: TopicPreview;
};

export type ArticleIndexType = "all" | "recent" | "recommended";

export interface ArticlesIndexParams {
  type: ArticleIndexType;
}

export type ArticlesIndexResponse = ArticlePreview[];

export const articlesIndexQuery = (params: ArticlesIndexParams) => ({
  url: url,
  method: "GET",
  params: cleanObj(params),
});

export interface ArticlesSearchParams {
  query: string;
}

export type ArticlesSearchResponse = {
  completion: string;
  contextSources: ArticlePreview[];
};

export const articlesSearchQuery = (params: ArticlesSearchParams) => ({
  url: "/api/v1/articles_search",
  method: "GET",
  params: cleanObj(params),
});

export interface ArticlesShowParams {
  draft?: boolean;
  slug: string;
  topic: string;
}

// ! If this is modified, ensure to change _open_graph.html.erb
export type Article = {
  _id: string;
  additionalResources: AdditionalResource[];
  author: AuthorPreview;
  body: PortableTextBlock[];
  dek: string;
  hasTableOfContents: boolean;
  heroImageAlt: string;
  heroImageSrc: string;
  isLocked: boolean;
  medicalExpert?: MedicalExpertPreview;
  metaDescription: string;
  metaTitle: string;
  publishedAt: string;
  relatedArticles: RelatedArticle[];
  shortestAnswer: PortableTextBlock[];
  slug: string;
  title: string;
  topic: TopicPreview;
  updatedAt: string;
};

export type AdditionalResource = {
  _id: string;
  description: string;
  resourceLink: string;
  title: string;
};

type AuthorPreview = {
  _id: string;
  alt: string;
  credentials: string;
  descriptionPopover: string;
  hasBioPage: boolean;
  imgSrc: string;
  name: string;
  slug: string;
};

export interface FeaturedArticlePreview extends TopicArticlePreview {
  dek: string;
}

type MedicalExpertPreview = {
  _id: string;
  alt: string;
  credentials: string;
  descriptionPopover: string;
  hasBioPage: boolean;
  imgSrc: string;
  name: string;
  slug: string;
};

export type RelatedArticle = {
  _id: string;
  heroImageAlt: string;
  heroImageSrc: string;
  isLocked: boolean;
  slug: string;
  title: string;
  topic: TopicPreview;
};

export interface TopicArticlePreview {
  _id: string;
  heroImageAlt: string;
  heroImageSrc: string;
  isLocked: boolean;
  slug: string;
  title: string;
}

export const articlesShowQuery = ({ slug, ...params }: ArticlesShowParams) => ({
  url: `${url}/${slug}`,
  method: "GET",
  params: cleanObj(params),
});
